(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("simple", [], factory);
	else if(typeof exports === 'object')
		exports["simple"] = factory();
	else
		root["simple"] = factory();
})(self, function() {
return 